import { io } from "socket.io-client";
import { useDeviceStore } from "@/stores/device";

let instance = null;

class SocketService {
  socket = null;
  connected = false;

  constructor() {
    if (instance) {
      return instance;
    }
    instance = this;
  }

  connect(token) {
    if (this.socket) return;
    //http://127.0.0.1:3010/
    this.socket = io("https://www.abyarinovin.ir/", {
      auth: { token },
      reconnectionAttempts: 5,
      reconnectionDelay: 2000,
      autoConnect: false,
      transports: ["websocket"],
      withCredentials: true,
    });

    this.socket.on("connect", () => {
      this.connected = true;
      console.log("✅ Connected to socket");
      const deviceStore = useDeviceStore();
      this.joinRoom(deviceStore.activeDevice?.pin);
      this.joinRoom("manger");
    });

    this.socket.on("disconnect", () => {
      this.connected = false;
      console.log("❌ Disconnected from socket");
    });

    this.socket.on("connect_error", (err) => {
      console.error("Connection error:", err.message);
    });

    this.socket.connect();
  }

  disconnect() {
    this.leaveRoom();
    this.socket?.disconnect();
    this.socket = null;
  }

  joinRoom(room) {
    if (this.connected && room) {
      this.socket.emit("join/room", { room });
      console.log("🟢 Joined room:", room);
    }
  }

  leaveRoom(room) {
    if (this.connected && room) {
      this.socket.emit("leave/room", { room });
      console.log("🔴 Left room:", room);
    }
  }

  emit(event, data) {
    if (this.socket?.connected) {
      this.socket.emit(event, data);
    }
  }

  on(event, callback) {
    this.socket?.on(event, callback);
  }

  off(event) {
    this.socket?.off(event);
  }

  once(event, callback) {
    this.socket?.once(event, callback);
  }
}

export default new SocketService();
